import React from 'react'
import { Descriptions } from 'antd'
import { CompanyData } from '../../../../services/api/companies'
import { Property } from '../../../../components'
import { displayDate } from '../../../../utils/formatter'

const { Item } = Descriptions
type Props = {
  company: CompanyData
}

export const Card: React.FunctionComponent<Props> = ({ company }) => {
  return (
    <Descriptions bordered column={1}>
      <Item label="Общая информация">
        <Property label="Руководитель">{company.manager}</Property>
        <Property label="Юридический адрес">{company.businessAddress}</Property>
        <Property label="Почтовый адрес">{company.postalAddress}</Property>
        <Property label="ИНН">{company.inn}</Property>
        <Property label="КПП">{company.kpp}</Property>
        <Property label="БИК">{company.bic}</Property>
        <Property label="Расчетный счет">{company.account}</Property>
        <Property label="Дата регистрации">
          {displayDate(company.createdAt)}
        </Property>
      </Item>
    </Descriptions>
  )
}
